import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaButton'

type IcaButtonIconProps = React.JSX.IntrinsicElements['tgdb-ica-button-icon']

export const IcaButtonIcon = wrapWc<IcaButtonIconProps>('tgdb-ica-button-icon', [])